export class SetDeviceSettingsAction {
    constructor(state) {
        this.name = 'SetDeviceSettings';
        this.isDeviceAction = true;
        this.data = {};
        this.data = Object.assign({}, state);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2V0RGV2aWNlU2V0dGluZ3NBY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21vZGVscy9hY3Rpb25zL1NldERldmljZVNldHRpbmdzQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFBLE1BQU0sT0FBTyx1QkFBdUI7SUFLbEMsWUFBWSxLQUFxQjtRQUpqQixTQUFJLEdBQUcsbUJBQW1CLENBQUM7UUFDM0IsbUJBQWMsR0FBRyxJQUFJLENBQUM7UUFDL0IsU0FBSSxHQUFpQyxFQUFFLENBQUM7UUFHN0MsSUFBSSxDQUFDLElBQUkscUJBQVEsS0FBSyxDQUFFLENBQUM7SUFDM0IsQ0FBQztDQUNGIn0=